<script setup>
defineEmits(['click']);
</script>

<template>
    <button
        class="btn-neutral"
        type="button"
        @click="$emit('click')"
    >
        <slot />
    </button>
</template>

<style scoped>
.btn-neutral {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: #ffffff;
    cursor: pointer;
    border: 1px solid #E2E8F0;
    padding: 6px 14px;
    border-radius: 6px;
    color: #475569;
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    transition: all 0.15s ease-in-out;
}

.btn-neutral:hover {
    background-color: #F8FAF7;
    border-color: #CBD5E1;
    color: #1E293B;
}

.btn-neutral:active {
    background-color: #F1F5F9;
    transform: translateY(0.5px);
}

:deep(svg) {
    flex-shrink: 0;
    color: currentColor;
}
</style>